import { SagaIterator } from 'redux-saga';
import { put } from 'redux-saga/effects';

import { clearSpaceContentCountsAction, contentCountsRequest } from '~src/app/actions/spaces/ContentCountsActions';
import { PublishedConnectionCountsRequestAction } from '~src/publishedConnection/actions/PublishedConnectionCountsRequestAction';

export function* handlePublishedConnectionCountsRequest(action: PublishedConnectionCountsRequestAction): SagaIterator {
  yield put(clearSpaceContentCountsAction(action.spaceType));
  yield put(contentCountsRequest());
}
